import ErrorUtil from '../error/ErrorUtil';
import API from '../util/ApiUtil';
import RootStore from './RootStore';
import SsoStore from './SsoStore';

class DiscountStore {
  private ssoStore: SsoStore;

  public constructor(rootStore: RootStore) {
    this.ssoStore = rootStore.ssoStore;
  }

  public hasDiscount = (productOfferingCodes: string[], discountCodes: string[]) => {
    if (!this.ssoStore.customer) {
      return false;
    }
    return this.fetchDiscount(productOfferingCodes[0], discountCodes);
  };

  public fetchDiscount = async (productOfferingCode: string, discountCodes: string[]) => {
    try {
      const response = await API.get(`/product/discount?productOfferingCode=${productOfferingCode}&discountCodes=${discountCodes.join(',')}`);
      return response.data;
    } catch (e) {
      ErrorUtil.pushErrorToTeliaRumAndLog(e as Error);
    }
  };
}

export default DiscountStore;
